module.exports = __webpack_public_path__ + "d8328b135964b48b807ccc109267e8dc.pdf";